<template>
    <Contenuti :modulo="30"></Contenuti>
</template>
<script>
import Contenuti from '@/views/content/Contenuti.vue'


export default {
    name:"Manuale",
    components:{
        Contenuti,
    },
}
</script>